import { useRouter } from "next/router";
import Image from "next/image";
import notfoundpage from "../public/images/notfoundpage.png";

export default function Custom404() {
  const router = useRouter();
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <Image
          src={notfoundpage}
          alt="404 Background"
          fill
          style={{ objectFit: "cover" }}
          priority
        />
      </div>

      {/* Content with higher z-index to appear above the background */}
      <div className="relative z-10">
        <h1 className="text-[12rem] font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#3D1781] to-[#7618FF] translate-y-10">
          404
        </h1>
        <h2 className="text-4xl font-medium my-4">Oops! Page Not Found</h2>
        <p className="mt-4 mb-6 text-2xl">
          It looks like you've hit a dead end. But don't worry, head back to{" "}
          <button
            onClick={() => router.push("/home")}
            className="text-purple-600 px-2 py-1 rounded hover:text-purple-700 transition-colors"
          >
            mple.ai
          </button>{" "}
          and explore
        </p>
        <p className="text-2xl">
          {" "}
          how our AI-powered roleplay can transform your training experience!🚀
        </p>
      </div>
    </div>
  );
}
